import React from 'react';
import './NoReps.styl';

export default class NoReps extends React.PureComponent {
  render() {
    const teamOwner = this.props.isManagerLoggedIn ? 'Your' : `${this.props.manager.firstName}'s`;
    const {forCoach} = this.props;
    const team = forCoach ? 'Coaching' : 'Team';
    const youDo = this.props.isManagerLoggedIn ? 'You do' : `${this.props.manager.firstName} does`;
    const message = forCoach
      ? `${youDo} not have any coaching plans with reps`
      : 'This team has no reps with plans.';
    return (
      <div className="mgr-landing-card-container no-reps-found-container">
        <div className="subheader">
          <h2 className="title">
            {teamOwner} {team}
          </h2>
        </div>
        <p className="no-reps-found">{message}</p>
      </div>
    );
  }
}
